// test1206
(1206 && 0);
